import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnitType } from '../models/unit-type';

@Injectable({
  providedIn: 'root'
})
export class UnitTypeService {

  constructor(private http:HttpClient) { }

  async getTypes() : Promise<UnitType[]> {
    return this.http.get<UnitType[]>('/api/unittype')
      .toPromise();
  }
}
